import React from 'react';

import { PropsFromInputs } from '../../types';

import { LeftTitleDecoration, RightTitleDecoration, TitleContainer } from './layout';

type Props = PropsFromInputs<typeof import('./inputs').default>;

export default ({ title }: Props) => {
  return (
    <TitleContainer>
      <LeftTitleDecoration width={35} />
      <h2>{title}</h2>
      <RightTitleDecoration />
    </TitleContainer>
  );
};
